module.exports = __webpack_public_path__ + "static/img/3.1.14a0aa76.png";